"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Banner = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _CloseIcon = require("../../svgs/CloseIcon");

var _Box = require("../Box");

var _Flex = require("../Flex");

var _Typography = require("../Typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Target = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "Banner__Target",
  componentId: "sc-1bfmimv-0"
})(["padding-left:10px;cursor:pointer;svg{display:block;}"]);
var Wrapper = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Banner__Wrapper",
  componentId: "sc-1bfmimv-1"
})(["transition:background-color 250ms linear;display:flex;"]);
var TextWrapper = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "Banner__TextWrapper",
  componentId: "sc-1bfmimv-2"
})(["width:100%;text-align:center;align-items:center;justify-content:center;"]);

var CloseButton = function CloseButton(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/_react.default.createElement(Target, {
    onClick: onClick,
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_CloseIcon.CloseIcon, {
    fill: "white100"
  }));
};

CloseButton.displayName = "CloseButton";

/**
 * A banner
 */
var Banner = /*#__PURE__*/function (_React$Component) {
  _inherits(Banner, _React$Component);

  var _super = _createSuper(Banner);

  function Banner() {
    var _this;

    _classCallCheck(this, Banner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      dismissed: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleCloseClick", function () {
      _this.setState({
        dismissed: true
      });
    });

    return _this;
  }

  _createClass(Banner, [{
    key: "render",
    value: function render() {
      if (this.state.dismissed) return null;
      var showCloseButton = this.props.dismissable;
      return /*#__PURE__*/_react.default.createElement(Wrapper, {
        bg: this.props.backgroundColor,
        color: this.props.textColor,
        p: 1
      }, /*#__PURE__*/_react.default.createElement(TextWrapper, null, /*#__PURE__*/_react.default.createElement(_Typography.Sans, {
        size: "2"
      }, this.props.children || this.props.message)), showCloseButton && /*#__PURE__*/_react.default.createElement(CloseButton, {
        onClick: this.handleCloseClick
      }));
    }
  }]);

  return Banner;
}(_react.default.Component);

exports.Banner = Banner;

_defineProperty(Banner, "defaultProps", {
  dismissable: false,
  backgroundColor: "red100",
  textColor: "white100"
});

Banner.displayName = "Banner";
//# sourceMappingURL=Banner.js.map